/**
 * Product Finder - Shopify Horizons
 * Handles dependent dropdown logic for Brand > Type > Product
 */
(function () {
    const initFinder = () => {
        const containers = document.querySelectorAll('[data-product-finder]');

        containers.forEach(container => {
            const dataElement = container.querySelector('[data-finder-data]');
            if (!dataElement) return;

            const finderData = JSON.parse(dataElement.textContent);
            const brandSelect = container.querySelector('[data-finder-next="type"]');
            const typeSelect = container.querySelector('[data-finder-next="product"]');
            const productSelect = container.querySelector('[data-finder-final]');

            const resetSelect = (select, placeholderKey) => {
                select.disabled = true;
                select.innerHTML = `<option value="">${select.options[0].text}</option>`;
            };

            // Handle Brand Change
            brandSelect.addEventListener('change', (e) => {
                const brand = e.target.value;
                resetSelect(typeSelect);
                resetSelect(productSelect);

                if (brand && finderData[brand]) {
                    typeSelect.disabled = false;
                    Object.keys(finderData[brand]).forEach(type => {
                        const opt = document.createElement('option');
                        opt.value = type;
                        opt.textContent = type;
                        typeSelect.appendChild(opt);
                    });
                }
            });

            // Handle Type Change
            typeSelect.addEventListener('change', (e) => {
                const brand = brandSelect.value;
                const type = e.target.value;
                resetSelect(productSelect);

                if (type && finderData[brand][type]) {
                    productSelect.disabled = false;
                    finderData[brand][type].forEach(prod => {
                        const opt = document.createElement('option');
                        opt.value = prod.url;
                        opt.textContent = prod.title;
                        productSelect.appendChild(opt);
                    });
                }
            });

            // Handle Final Selection (Redirect)
            productSelect.addEventListener('change', (e) => {
                if (e.target.value) {
                    window.location.href = e.target.value;
                }
            });
        });
    };

    // Initialize on load and for theme editor support
    initFinder();
    document.addEventListener('shopify:section:load', initFinder);
})();